import useLoaderHook from "./useLoaderHook";

/**
 * Esporta dal loader solo i metodi per visualizzarlo e nasconderlo.
 */
export default function ShowHideLoader() {
    const [, , hideLoader, showLoader,] = useLoaderHook();
    return [showLoader, hideLoader];
};
